import React, { useEffect, useState } from "react";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("/");

  useEffect(() => {
    const updateActive = () => {
      const hash = window.location.hash || "/";
      setActive(hash === "#" || hash === "" ? "/" : hash);
    };

    updateActive();
    window.addEventListener("hashchange", updateActive);
    window.addEventListener("popstate", updateActive);
    return () => {
      window.removeEventListener("hashchange", updateActive);
      window.removeEventListener("popstate", updateActive);
    };
  }, []);

  const handleLinkClick = (href) => {
    setActive(href === "#" || href === "" ? "/" : href);
    setMenuOpen(false);
  };

  return (
    <header className={`navbar ${menuOpen ? "nav-open" : ""}`}>
      <div className="logo">
        <h1>Auratek Digitals</h1>
      </div>

      <button
        className={`burger ${menuOpen ? "open" : ""}`}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((s) => !s)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`links ${menuOpen ? "open" : ""}`} aria-hidden={!menuOpen}>
        <ul>
          <li>
            <a
              href="/"
              className={active === "/" ? "active" : ""}
              onClick={() => handleLinkClick("/")}
            >
              Home
            </a>
          </li>
          <li className="desktop-only">
            <a
              href="#about"
              className={active === "#about" ? "active" : ""}
              onClick={() => handleLinkClick("#about")}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#services"
              className={active === "#services" ? "active" : ""}
              onClick={() => handleLinkClick("#services")}
            >
              Services
            </a>
          </li>
          <li className="mobile-only">
            <a
              href="#why-us"
              className={active === "#why-us" ? "active" : ""}
              onClick={() => handleLinkClick("#why-us")}
            >
              Why Us
            </a>
          </li>
          <li className="mobile-only">
            <a
              href="#how-it-works"
              className={active === "#how-it-works" ? "active" : ""}
              onClick={() => handleLinkClick("#how-it-works")}
            >
              How It Works
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className={`${active === "#contact" ? "active" : ""} mobile-contact`}
              onClick={() => handleLinkClick("#contact")}
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>

      <div className="action">
        <a href="#contact" className="button" onClick={() => handleLinkClick("#contact")}>Contact</a>
      </div>
    </header>
  );
}
